export default "__VITE_ASSET__J2BESewS__"